import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Menu,
    Box,
    Typography,
    Divider,
    Switch,
    MenuItem,
    TextField,
    InputAdornment,
    Button,
    Avatar
} from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/Search';
import SettingsRoundedIcon from '@mui/icons-material/Settings';
import LogoutRoundedIcon from '@mui/icons-material/Logout';
import PersonRoundedIcon from '@mui/icons-material/Person';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

const ProfileMenu = ({ anchorEl, onClose }) => {
    const navigate = useNavigate();
    const open = Boolean(anchorEl);
    const [userData, setUserData] = useState({});
    const [configOpen, setConfigOpen] = useState(false);

    useEffect(() => {
        const storedUserData = localStorage.getItem("userData");
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData));
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('sessionStart');
        localStorage.removeItem('userData');
        onClose(); // Cierra el menú
        navigate('/'); // Redirige a la página de login
    };

    const handleConfigOpen = () => {
        setConfigOpen(true);
        onClose(); // Cierra el menú principal
    };

    const handleConfigClose = () => {
        setConfigOpen(false);
    };

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={onClose}
                PaperProps={{
                    sx: { width: 300, p: 2, borderRadius: 3 }
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar alt={userData.nombre} src={userData.foto || undefined} sx={{ mr: 2 }} />
                    <Box>
                        <Typography variant="subtitle2" sx={{ color: '#888' }}>
                            Buenos días,
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {userData.nombre || 'Cargando...'}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#aaa' }}>
                            {/* Aquí puedes mostrar el rol del usuario si lo tienes en userData */}
                            {userData.rol_idRol === 1 ? 'Administrador' : 'Usuario'} del proyecto
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ mb: 1 }} />

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2">Activar modo No molestar</Typography>
                        <Switch size="small" defaultChecked />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2">Permitir notificaciones</Typography>
                        <Switch size="small" />
                    </Box>
                </Box>

                <Divider sx={{ mb: 1 }} />

                <MenuItem onClick={handleConfigOpen}>
                    <SettingsRoundedIcon fontSize="small" sx={{ mr: 1 }} />
                    Configuración de cuenta
                </MenuItem>
                <MenuItem>
                    <PersonRoundedIcon fontSize="small" sx={{ mr: 1 }} />
                    Perfil social
                    <Box component="span" sx={{
                        backgroundColor: '#ffeb3b',
                        fontSize: 10,
                        borderRadius: '6px',
                        px: 1.5,
                        ml: 'auto'
                    }}>
                        02
                    </Box>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    <LogoutRoundedIcon fontSize="small" sx={{ mr: 1 }} />
                    Cerrar sesión
                </MenuItem>
            </Menu>

            {/* Modal de Configuración de Cuenta */}
            <Dialog open={configOpen} onClose={handleConfigClose} fullWidth maxWidth="sm">
                <DialogTitle>Configuración de Cuenta</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="h6">Información del Usuario</Typography>
                    <Box sx={{ mt: 2, mb: 2 }}>
                        <Typography variant="body1">
                            **ID de Usuario:** {userData.idUsuario}
                        </Typography>
                        <Typography variant="body1">
                            **Nombre:** {userData.nombre}
                        </Typography>
                        <Typography variant="body1">
                            **Correo:** {userData.correo}
                        </Typography>
                        <Typography variant="body1">
                            **Usuario:** {userData.usuario}
                        </Typography>
                        <Typography variant="body1">
                            **RUT:** {userData.rut}
                        </Typography>
                        <Typography variant="body1">
                            **Empresa:** {userData.nombre_empresa}
                        </Typography>
                        <Typography variant="body1">
                            **Rol ID:** {userData.rol_idRol}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfigClose}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ProfileMenu;